import { render, staticRenderFns } from "./draggable-table-row-handler.vue?vue&type=template&id=4de1c839&scoped=true"
import script from "./draggable-table-row-handler?vue&type=script&lang=js&external"
export * from "./draggable-table-row-handler?vue&type=script&lang=js&external"
import style0 from "./draggable-table-row-handler.vue?vue&type=style&index=0&id=4de1c839&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de1c839",
  null
  
)

export default component.exports